module.exports = __webpack_public_path__ + "img/BQ-SE.3fd36bff.svg";